import { useMemo } from "react";

const DiamondStar = ({ size = 12, color = "#FFFFFF" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 0 L14.2 9.8 L24 12 L14.2 14.2 L12 24 L9.8 14.2 L0 12 L9.8 9.8 Z" fill={color} />
    </svg>
);

export const Sparkles = ({ count = 12, className = "" }) => {
    const stars = useMemo(() => {
        let seed = 42;
        const rand = () => {
            seed = (seed * 16807) % 2147483647;
            return (seed - 1) / 2147483646;
        };
        return Array.from({ length: count }, (_, i) => ({
            id: i,
            left: `${rand() * 100}%`,
            top: `${rand() * 100}%`,
            size: 6 + rand() * 12,
            delay: `${rand() * 4}s`,
            duration: `${2.6 + rand() * 2.6}s`,
            color: rand() > 0.45 ? "#FFFFFF" : "#C9CDD6",
        }));
    }, [count]);

    return (
        <div aria-hidden="true" className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}>
            {stars.map((s) => (
                <span
                    key={s.id}
                    className="absolute animate-twinkle"
                    style={{ left: s.left, top: s.top, animationDelay: s.delay, animationDuration: s.duration }}
                >
                    <DiamondStar size={s.size} color={s.color} />
                </span>
            ))}
        </div>
    );
};

export const DiamondDivider = ({ className = "" }) => (
    <div className={`flex items-center justify-center gap-3 ${className}`} aria-hidden="true">
        <span className="h-px w-16 sm:w-24 bg-gradient-to-r from-transparent to-gold/70" />
        <DiamondStar size={14} color="#C0C0C0" />
        <span className="h-px w-16 sm:w-24 bg-gradient-to-l from-transparent to-gold/70" />
    </div>
);
